import { formatDate } from "../../../../../../components/controllers/calendar-controller/format-date.config";

export const preloadedValues = {
    hdayRecStatus: false,
    hdayData:formatDate(new Date()),
    hdayPermanente: false,
    hdayDescricao: "",
  };
  